export type { Props as LabelPickerProps, LabelPickerOption } from './label-picker-dumb';
export { default as LabelPickerDumb } from './label-picker-dumb';
